import {Skeleton, Typography} from '@mui/material';
import Grid from '@mui/material/Grid2';

const MyAchievementInfoSkeleton = () => (
  <Grid
    size={12}
    width={'100%'}
    container
    p="1rem"
    justifyContent="space-between"
    alignItems="center"
    display={'flex'}
    flexDirection={'column'}
    bgcolor="background.paper"
    sx={{
      borderRadius: theme => theme.shape.borderRadius,
    }}>
    <Grid
      size={12}
      display={'flex'}
      p={'12px'}
      sx={{
        backgroundColor: 'background.default',
        borderRadius: '12px',
      }}
      alignItems={'center'}
      justifyContent={'space-between'}>
      <Grid size={12} container alignItems={'center'} spacing={1}>
        <Grid
          size="auto"
          sx={{
            height: '42px',
          }}>
          <Skeleton
            variant="rectangular"
            width={45}
            height={45}
            sx={{
              borderRadius: '0.75rem',
            }}
          />
        </Grid>
        <Grid size={'grow'} display={'flex'} flexDirection={'column'} container>
          <Skeleton variant="rectangular" width="80px" height={'0.75rem'} />
          <Grid size={12} gap={'4px'} display={'flex'} alignItems={'center'}>
            <Skeleton variant="rectangular" width="20px" height={'1rem'} />
            <Skeleton variant="rectangular" width="100px" height={'1rem'} />
          </Grid>
        </Grid>
      </Grid>
      <Grid mr={1}>
        <Skeleton variant="rectangular" width="60px" height={'1rem'} />
      </Grid>
    </Grid>
    <Grid
      size={12}
      mt={2}
      display={'flex'}
      p={'12px'}
      sx={{
        backgroundColor: 'background.default',
        borderRadius: '12px',
      }}
      flexDirection={'column'}>
      <Grid>
        <Skeleton variant="rectangular" width="100px" height={'0.7rem'} />
      </Grid>
      <Grid
        size={12}
        display={'flex'}
        alignItems={'center'}
        mt={2}
        justifyContent={'space-between'}>
        {[0, 1, 2, 3].map(item => (
          <Grid key={item}>
            <Skeleton variant="circular" width="64px" height="64px" />
            <Typography
              fontSize="1.125rem"
              width="100%"
              lineHeight="1.54rem"
              mt="0.1rem"
              fontFamily="Alfa Slab One">
              <Skeleton width="100%" />
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  </Grid>
);

export default MyAchievementInfoSkeleton;
